import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, PopoverController } from 'ionic-angular';
import { Service } from '../../app/service';
import { DomSanitizer} from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BarcodeScanner } from 'ionic-native';

@Component({
  selector: 'page-qrcode',
  templateUrl: 'qrcode.html'
})
export class QrCode {

  bild_qr: any;
  qrdata: any;

  constructor(public navCtrl: NavController, private navParams: NavParams, private DataProvider: Service) {
    console.log("qr code");
    this.qrdata = navParams.get('qrdata');
    this.bild_qr = "https://api.qrserver.com/v1/create-qr-code/?data=" + this.qrdata;

    console.log("qr bild", this.bild_qr);

  }
}



// WEBPACK FOOTER //
// ./src/pages/qrcode/qrcode.ts